export default "__VITE_ASSET__B6HP8PJs__"